module.exports = __webpack_public_path__ + "img/DE00325.8d291d93.png";